const SafetyIconVibrationCautionGreen = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M6 13.5996L8.4 15.9996L6 18.3996L8.4 20.7996L6 23.1996M30 13.5996L27.6 15.9996L30 18.3996L27.6 20.7996L30 23.1996"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.6002 10H14.4002C13.7375 10 13.2002 10.5373 13.2002 11.2V25.6C13.2002 26.2627 13.7375 26.8 14.4002 26.8H21.6002C22.2629 26.8 22.8002 26.2627 22.8002 25.6V11.2C22.8002 10.5373 22.2629 10 21.6002 10Z"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SafetyIconVibrationCautionGreen
